import React, { Component } from 'react';
import { observer } from 'mobx-react';
import LeftPanelItem from "Components/LeftPanel/leftPanelItem";

class LeftPanelItemsUsersMetrics extends Component {

    constructor() {
        super();
    }

    render() {
        return (
            <div>
                <LeftPanelItem
                    title='Назад'
                    linkTo={`${window.SmrLocation}/stats`}
                    icon="us-back-menu"
                    isSelected={true}
                />
            </div>
        );
    }
}

export default observer(LeftPanelItemsUsersMetrics);